export default __webpack_public_path__ + "static/1-5-3-2-a369838510146f09efaf17d708ec10fd.jpg";